import { ViewModelForm } from "@xengage/gw-portals-viewmodel-react";
import React, { useCallback, useContext, useState } from "react";
import cx from 'classnames'
import { Flex } from '@jutro/layout'
import { Chevron, Icon } from '@jutro/components';
import { TranslatorContext } from "@jutro/locale";
import _ from 'lodash'
import metadata from './TWIABuildingInfoAccordion.metadata.json5'
import styles from '../TWIABuildingSummaryAccordions.module.scss';
import messages from './TWIABuildingInfoAccordion.messages.js';
import { BldgLocContext } from '../../../context/BuildingsAndLocationContext';

function TWIABuildingInfoAccordion(props) {
    const { handleEditLinkClick, wizardStep, isConfirmationStep } = props;
    const translator = useContext(TranslatorContext)
    const { chosenLocation, chosenBuildingIndex } = useContext(BldgLocContext);
    const [selectedLocation] = chosenLocation;
    const [selectedBuildingIndex, setSelectedBuildingIndex] = chosenBuildingIndex;
    const [building, setBuilding] = useState(selectedLocation.buildings.children[selectedBuildingIndex]);

    const buildingHeader = useCallback((isOpen) => (
        <Flex justifyContent="between" className={styles.fullWidth}>
            <Icon
                icon="gw-home-work"
                id="locCheck"
                size="medium"
            />
            <div className={cx(styles.heading, styles.headingBold, styles.flexOneThird)}>{translator(messages.buildingHeading)}</div>
            <div className={cx(styles.heading, styles.flexOneThird)}>{_.get(building, 'description.value')}</div>
            <Chevron className={styles.chevronMargin} isOpen={isOpen} />
        </Flex>
    ), [building, translator])

    const editBuilding = useCallback(() => {
        if (wizardStep === -1 || isConfirmationStep) {
            handleEditLinkClick(1, false, undefined, undefined, building)
        } else {
            handleEditLinkClick(1, undefined, undefined, undefined, building)
        }
    }, [])

    const resolvers = {
        resolveCallbackMap: {
            buildingHeader,
            editBuilding
        },
        resolveClassNameMap: styles
    }

    const overrideProps = {
        buildingClassCode: {
            value: _.get(building, 'classCode') ? `${_.get(building, 'classCode.code.value')}: ${_.get(building, 'classCode.classification.value')}` : '-'
        }
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={building}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    )
}

export default TWIABuildingInfoAccordion
